import {handleAjaxError} from "../../../actions/handleAjaxError";

export function swipeQuiz() {
    window.growtypeQuizId = $('.growtype-quiz-wrapper').attr('id');

    document.addEventListener('growtypeQuizShowQuestion', function (event) {
        let nextQuestion = event['detail']['currentQuestion'];

        if ($(nextQuestion).attr('data-key') === 'swipequiz') {
            const urlParams = new URLSearchParams(window.location.search);
            const gender = urlParams.get('gender');
            window.user_prefered_gender = gender ?? 'female';

            growtypeQuizGetSwipeQuiz(nextQuestion);
        }
    });

    /**
     * Swipe Quiz
     * @param el
     * @param func
     */
    function detectswipe(el, func) {
        let swipe_det = new Object();
        swipe_det.sX = 0;
        swipe_det.sY = 0;
        swipe_det.eX = 0;
        swipe_det.eY = 0;
        var min_x = 90;  //min x swipe for horizontal swipe
        var max_x = 90;  //max x difference for vertical swipe
        var min_y = 550;  //min y swipe for vertical swipe
        var max_y = 560;  //max y difference for horizontal swipe
        var direc = "";
        let all_ele = document.getElementsByClassName(el);
        for (var i = 0; i < all_ele.length; ++i) {
            let ele = document.getElementsByClassName(el)[i];
            ele.addEventListener('touchstart', function (e) {
                var t = e.touches[0];
                swipe_det.sX = t.screenX;
                swipe_det.sY = t.screenY;
            }, false);
            ele.addEventListener('touchmove', function (e) {
                e.preventDefault();
                var t = e.touches[0];
                swipe_det.eX = t.screenX;
                swipe_det.eY = t.screenY;
            }, false);
            ele.addEventListener('touchend', function (e) {
                //horizontal detection
                if ((((swipe_det.eX - min_x > swipe_det.sX) || (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) && (swipe_det.sY > swipe_det.eY - max_y) && (swipe_det.eX > 0)))) {
                    if (swipe_det.eX > swipe_det.sX) direc = "r";
                    else direc = "l";
                }
                //vertical detection
                else if ((((swipe_det.eY - min_y > swipe_det.sY) || (swipe_det.eY + min_y < swipe_det.sY)) && ((swipe_det.eX < swipe_det.sX + max_x) && (swipe_det.sX > swipe_det.eX - max_x) && (swipe_det.eY > 0)))) {
                    if (swipe_det.eY > swipe_det.sY) direc = "d";
                    else direc = "u";
                }

                if (direc != "") {
                    if (typeof func == 'function') func($(this), direc);
                }
                direc = "";
                swipe_det.sX = 0;
                swipe_det.sY = 0;
                swipe_det.eX = 0;
                swipe_det.eY = 0;
            }, false);
        }
    }

    function getQuizMatchAnswers() {
        return JSON.parse(growtypeCookie.getCookie('growtype_quiz_match_answers')) ?? {};
    }

    function moveSlideLeft(activeImage, answerEmotion) {
        activeImage.append('<div class="btn-status btn-status-nope">Nope</div>');
        setTimeout(function () {
            activeImage.hide("slide", {direction: "left"}, 500).promise().done(function () {
                activeImage
                    .removeClass('is-active')
                    .next()
                    .addClass('is-active')
                    .find('.swipequiz-single-images')
                    .slick();
                initSwipeQuizTrigger()
                // evaluateQuizState();
            });
        }, 500)
    }

    function moveSlideRight(activeImage, answerEmotion) {
        if (answerEmotion === 'superlike') {
            activeImage.append('<div class="btn-status btn-status-superlike anim-pulse">Wow!</div>')
        } else {
            activeImage.append('<div class="btn-status btn-status-like">Like</div>')
        }
        setTimeout(function () {
            activeImage.hide("slide", {direction: "right"}, 500).promise().done(function () {
                activeImage
                    .removeClass('is-active')
                    .next()
                    .addClass('is-active')
                    .find('.swipequiz-single-images')
                    .slick();
                initSwipeQuizTrigger()
                // evaluateQuizState();
            });
        }, 500)
    }

    detectswipe('swipequiz-single', function (el, d) {
        if (d === 'l') {
            $('.b-actions .btn-hate').trigger('click')
        } else {
            $('.b-actions .btn-like').trigger('click')
        }
    });

    function initSwipeQuizTrigger() {
        var btnClicked = true;
        $('.growtype-quiz-question[data-key="swipequiz"] .b-actions .btn').click(function () {
            let button = $(this);
            let activeImage = button.closest('.swipequiz-wrapper').find('.swipequiz-single-wrapper.is-active');
            let modelSlug = activeImage.attr('data-model-slug');
            let answerEmotion = button.data('value');
            let answers = getQuizMatchAnswers();

            if (btnClicked) {
                btnClicked = false;

                button.addClass('is-active');
                setTimeout(function () {
                    button.removeClass('is-active')
                }, 300);

                /**
                 * Slide
                 */
                answers[modelSlug] = answerEmotion;

                growtypeQuizSubmitSwipe(activeImage, answerEmotion);
                growtypeQuizInitSwipe(activeImage, answerEmotion);

                growtypeCookie.setCookie('growtype_quiz_match_answers', JSON.stringify(answers))
            }
        });
    }

    function growtypeQuizGetSwipeQuiz(nextQuestion) {
        let formData = new FormData();
        formData.append("action", "growtype_quiz_get_swipequiz");
        formData.append("answers", JSON.stringify(getQuizMatchAnswers()));
        formData.append("gender", window.user_prefered_gender);

        $('.growtype-quiz-main-content-wrapper').append('<div class="swipequiz-loader"><i class="fa-solid fa-heart"></i></div>');

        $.ajax({
            type: "POST",
            url: growtype_quiz_local.ajax_url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            data: formData,
            success: function (response) {
                $(nextQuestion).find('.growtype-quiz-main-content-wrapper').html(response.content);
                $(nextQuestion).find('.growtype-quiz-main-content-wrapper .swipequiz-single-wrapper:first')
                    .addClass('is-active')
                    .find('.swipequiz-single-images')
                    .slick();

                initSwipeQuizTrigger();

                setTimeout(function () {
                    $('.growtype-quiz-main-content-wrapper').find('.swipequiz-loader').fadeOut(1200).promise().done(function () {
                        $(this).remove();
                    });
                    $('.swipequiz-wrapper').addClass('is-loaded')
                }, 500)
            }
        });
    }

    function growtypeQuizSubmitSwipe(activeImage, answerEmotion) {
        let formData = new FormData();
        let modelSlug = activeImage.attr('data-model-slug');

        formData.append("action", "growtype_quiz_evaluate_swipequiz");
        formData.append("answers", JSON.stringify(getQuizMatchAnswers()));
        formData.append("emotion", answerEmotion);
        formData.append("model", modelSlug);

        $.ajax({
            type: "POST",
            url: growtype_quiz_local.ajax_url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            data: formData,
            success: function (response) {

                if (response.content.length > 0) {
                    $('.swipequiz-wrapper').append(response.content);
                    $('.swipequiz-wrapper').find('.swipequiz-match').hide();

                    $('.swipequiz-wrapper').find('.swipequiz-match .e-close').click(function () {
                        $(this).closest('.swipequiz-match').fadeOut(600).promise().done(function () {
                            $(this).remove();
                        });
                    });

                    setTimeout(function () {
                        $('.swipequiz-wrapper').find('.swipequiz-match').fadeIn(600).find('.swipequiz-match-images').slick({
                            infinite: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 2000,
                            fade: true,
                            speed: 500,
                            cssEase: 'ease-in-out',
                            touchThreshold: 100
                        });
                    }, 1000);
                }

            },
            error: function (response) {
                growtypeCookie.setCookie('growtype_quiz_match_answers', JSON.stringify({}))
                handleAjaxError(response);
            }
        });
    }

    function growtypeQuizInitSwipe(activeImage, answerEmotion) {
        if (activeImage.next().next().length < 1) {
            let formData = new FormData();
            formData.append("action", "growtype_quiz_get_swipequiz_images");
            formData.append("answers", JSON.stringify(getQuizMatchAnswers()));
            formData.append("offset", $('.swipequiz-single-wrapper').length);
            formData.append("gender", window.user_prefered_gender);

            $.ajax({
                type: "POST",
                url: growtype_quiz_local.ajax_url,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                cache: false,
                data: formData,
                success: function (response) {
                    $(response.content).insertAfter(activeImage);

                    /**
                     * Slide
                     */
                    moveSlide(activeImage, answerEmotion)
                }
            });
        } else {
            moveSlide(activeImage, answerEmotion)
        }
    }

    function moveSlide(activeImage, answerEmotion) {
        if (answerEmotion === 'hate') {
            moveSlideLeft(activeImage, answerEmotion)
        } else if (answerEmotion === 'love') {
            moveSlideRight(activeImage, answerEmotion)
        } else if (answerEmotion === 'superlike') {
            moveSlideRight(activeImage, answerEmotion)
        }
    }
}
